export default __webpack_public_path__ + "static/media/fastlane_side.00a185e4.jpg";